import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableCasino from './block/table';
import {ReactComponent as ArrowRight} from '../../../../../@casino/img/right-arrow.svg';
import {ReactComponent as ArrowDown} from '../../../../../@casino/img/down-arrow.svg';
import {columns, getRows, useStyles} from './helpers';
import { setGetFreespinOperation } from '../../store/thunk/setGetFreespinOperation';

const BlockFreespin = ({id}) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    const [lastEvent, setLastEvent] = React.useState(false);

    React.useEffect(() => {
        if (lastEvent) {
            dispatch(setGetFreespinOperation({
                id,
                page: 1,
                rowsPerPage: 5
            }))
        }
    }, [lastEvent, id])

    const operation = useSelector(state => state.users.freespin);  

    const rows = React.useMemo(() => getRows(operation.data), [operation]);

    return (
        <div>
            <div 
                className={classes.wrapTitle}
                onClick={() => {
                    setLastEvent(!lastEvent)
                }}
            >
                <span
                    className={classes.title}
                >
                    Статистика по фриспинам
                </span>
                {
                    !lastEvent && 
                    <ArrowRight className={classes.arrow}/>
                }
                {
                    lastEvent && 
                    <ArrowDown className={classes.arrow}/> 
                }
            </div>
            <div>
                {
                    lastEvent &&
                    <TableCasino
                        allPage={operation.count}
                        width={1280}
                        perPage={5}
                        columns={columns}
                        rows={rows}
                        changeRowsPerPage={(v) => {
                            dispatch(setGetFreespinOperation({
                                page: 1,
                                rowsPerPage: v.rowsPerPage,
                                id
                            }))}
                        }
                    />
                }
            </div>
        </div>
    )
}

export default BlockFreespin;